import React, { Component } from "react"
// import { locales } from "../i18n"
import styled, { ThemeProvider } from "styled-components"

import LocaleContext from "../localeContext"

import "sanitize.css"
import "sanitize.css/typography.css"
import "sanitize.css/forms.css"

import Header from "../components/header"
import Footer from "../components/footer"
import Navigation from "../components/navigation/"

export default class extends Component {
  render() {
    const { children, pageContext } = this.props

    const { locale, basepath, fullpath } = pageContext

    const isHome = basepath === "/"

    return (
      <LocaleContext.Provider
        value={{ locale: locale, basepath: basepath, fullpath: fullpath }}
      >
        <ThemeProvider theme={themes.light}>
          <Site>
            <Header isHome={isHome} />
            <Navigation />
            <main>{children}</main>
            <Footer />
          </Site>
        </ThemeProvider>
      </LocaleContext.Provider>
    )
  }
}

const themes = {
  light: {
    colors: {
      contrast: "#191919",
      main: "#f2f2f2",
      wash: "#ffffff",
      accent: "#ec1234",
    },
    maxWidth: 960,
  },
}

const Site = styled.div`
  width: 100vw;
  min-height: 100vh;
  border: 0.5rem solid ${({ theme }) => theme.colors.accent};

  @media (min-width: 23.4375em) {
    border: 0.75rem solid ${({ theme }) => theme.colors.accent};
  }

  @media (min-width: 26.5625em) {
    border: 1rem solid ${({ theme }) => theme.colors.accent};
  }

  font-family: source-han-sans-japanese, sans-serif;
  font-weight: 200;
  font-style: normal;
`
